module.exports = {
  47: '12rem',
  120: '30rem',
  '70-screen': '70vh',
  '85-screen': '85vh',
  '95-screen': '95vh',
  '90-percentage': '90%',
};
